export default __webpack_public_path__ + "static/media/crypto white.3d4dfd1d.svg";